import { render, staticRenderFns } from "./Anulaciones.vue?vue&type=template&id=82112c56"
import script from "./Anulaciones.vue?vue&type=script&lang=js"
export * from "./Anulaciones.vue?vue&type=script&lang=js"
import style0 from "./Anulaciones.vue?vue&type=style&index=0&id=82112c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports